import { publicClient, privateClient } from './client';
import { PhysicalStoreCart } from './PhysicalStoreCart';

const customPhysicalStoreCart = (pub: boolean) => new PhysicalStoreCart(pub ? publicClient : privateClient);
export default customPhysicalStoreCart;
